export default __webpack_public_path__ + "static/media/cabo.7e82d5fd.JPG";